import { NotScrollJournalPage } from "components/frontComponents/notScrollJournalPage/NotScrollJournalPage";
import styles from "./styles.module.scss";
import First from "../../assets/images/routing/first.png";
import Second from "../../assets/images/routing/second.png";
import Third from "../../assets/images/routing/third.png";
import Desktop from "../../assets/images/routing/desktop.png";
import Mobile from "../../assets/images/routing/mobile.png";
import Telega from "../../assets/images/routing/telega.png";
import { Button } from "components/frontComponents/button/Button";
import { useNavigate } from "react-router-dom";
import { RouterPathEnum } from "../../shared/enums/commonEnums";
import Qr from "../../assets/images/routing/qr.png";

export const RoutingPage = () => {
  const navigate = useNavigate();
  return (
    <div className={styles.routing}>
      <NotScrollJournalPage
        leftContent={
          <div className={styles.containerLeft}>
            <div className={styles.leftleft}>
              <div className={styles.toptitle}>
                <h1 className={styles.bigtext}>Хроники Возрождения</h1>
                <h2 className={styles.subbigtext}>Твой путь в мире Остэон</h2>
                <div className={styles.blackline} />
                <div className={styles.textsmall}>
                  <h3 className={styles.underline}>Великий Распад не ждет. </h3>
                  <h3 className={styles.underline}>
                    Синхронизируй волю, разум и тело дабы переписать павший мир.
                  </h3>
                </div>
              </div>
              <div className={styles.leftpale}>
                <h3 className={styles.text}>
                  Можно использовать каждый компонент отдельно
                </h3>
                <div className={styles.textcontainer}>
                  <img src={First} alt="" style={{ width: 70, height: 70 }} />
                  <h3 className={styles.text}>
                    Десктопный клиент ОСТЭОН. Проходите тренировки для
                    стабилизации Эфира и вступайте в MMORPG.{" "}
                  </h3>
                </div>
                <div className={styles.textcontainer}>
                  <img src={Second} alt="" style={{ width: 70, height: 70 }} />
                  <h3 className={styles.text}>
                    Мобильное приложение КиберФит. Карманный центр управления
                    ОСТЭОН. Контролируйте мир без привязки к десктопу.
                  </h3>
                </div>
                <div className={styles.textcontainer}>
                  <img src={Third} alt="" style={{ width: 70, height: 70 }} />
                  <h3 className={styles.text}>
                    Телеграм КиберФит. Ваше тело — источник Эфира. Преобразуйте
                    движение в цифровую мощь для ОСТЭОН.
                  </h3>
                </div>
                <h3 className={styles.text}>
                  Только объединив Волю (Десктоп), Плоть (Мобильное приложение)
                  и Разум (Телеграм), вы достигнете полной синхронизации и
                  получите силу, чтобы возродить ОСТЭОН из пепла
                </h3>
              </div>
            </div>
            <div className={styles.rightleft}>
              <div className={styles.rightpale}>
                <h2 className={styles.title}>
                  ОСТЭОН на большом экране. Тренируйтесь и сражайтесь в цифровых
                  руинах
                </h2>
                <ul>
                  <li>
                    Тренировки: Наполняйте Эфиром свою цифровую экосистему через
                    систему упражнений.
                  </li>
                  <li>
                    MMORPG: Управляйте армией персонажей, вступайте в гильдии и
                    участвуйте в битвах за территории.
                  </li>
                  <li>
                    Синхронизация: Для использования motion-ахвата требуется
                    подключение к мобильному приложению «Интерфейс Плоти». Ваше
                    тело — источник силы в игре.
                  </li>
                </ul>
              </div>
              <div className={styles.imgholder}>
                <img src={Desktop} alt="" className={styles.photo} />
              </div>

              <div className={styles.linkholder}>
                <a href="https://lk.ssmu.ru/login" className={styles.text}>
                  скачать десктопное приложение
                </a>
              </div>
            </div>
          </div>
        }
        rightContent={
          <div className={styles.containerRight}>
            <div className={styles.holderRight}>
              <div className={styles.rightleft}>
                <div className={styles.imgholder}>
                  <img src={Mobile} alt="" className={styles.photo} />
                  <img src={Qr} alt="" className={styles.qr1} />
                </div>

                <div className={styles.rightpale}>
                  <h2 className={styles.title}>Мобильный шлюз ОСТЭОН</h2>
                  <h3 className={styles.text}>
                    Ваш карманный штаб для управления ОСТЭОН в любом месте.
                    Контролируйте цифровую жизнь без привязки к десктопу. Скачай
                    по qr-коду
                  </h3>
                  <ul>
                    <li>
                      Контракты на Эфир: Выполняйте задания (бег, стрельба,
                      бокс), чтобы заработать валюту. Каждое движение
                      переписывает код реальности.
                    </li>
                    <li>
                      Лаборатория: Вкладывайте Эфир в постройку лаборатории,
                      чтобы получать бонусы в десктопной игре.
                    </li>
                    <li>
                      Визуальный Канал: Следите за прогрессом через подгружаемые
                      арты и изображения.
                    </li>
                    <li>
                      Биометрический Анализ: Сканируйте еду (КБЖУ) и
                      отслеживайте активность для оптимизации генерации Эфира.
                    </li>
                    <li>
                      Беспроводной Ключ: Используйте приложение для доступа к
                      десктопной версии без отдельной регистрации.
                    </li>
                  </ul>
                </div>
              </div>
              <div className={styles.rightright}>
                <div className={styles.rightpale}>
                  <h2 className={styles.title}>ОСТЭОН у вас в кармане</h2>
                  <ul>
                    <li>
                      Легион: Просматривайте и пополняйте отряд персонажей (до 5
                      персонажей).
                    </li>
                    <li>
                      Хроники Забвения: Проходите сюжетные текстовые квесты и
                      когнитивные головоломки
                    </li>
                    <li>
                      Гильдии и Лиги: Вступайте в сообщества, отслеживайте свои
                      достижения и успехи союзников по лиге.
                    </li>
                    <li>
                      Спутник: Общайтесь с ИИ-проводником — голосом самого
                      ОСТЭОН.
                    </li>
                    <li>
                      Архив Эфира: Изучайте мир через встроенную энциклопедию.
                    </li>
                    <li>
                      Цифровой Кошелек: Получайте валюту за достижения и тратьте
                      её на артефакты.
                    </li>
                  </ul>
                </div>
                <div className={styles.imgholder}>
                  <img src={Telega} alt="" className={styles.photo} />
                  <img src={Qr} alt="" className={styles.qr2} />
                </div>

                <div className={styles.bottomtext}>
                  <h3 className={styles.text}>
                    Преобразуйте физическую активность в цифровую мощь. Ваше
                    тело — ретранслятор, питающий ваше «Я» в ОСТЭОН. Скачай по
                    qr-коду
                  </h3>
                </div>
              </div>
            </div>
            <div>
              <div className={styles.buttonholder}>
                <Button
                  viewVariant="primary"
                  className={styles.button}
                  text="Хочу участвовать"
                  onClick={() => navigate(RouterPathEnum.RegistrationPage)}
                />
                <Button
                  viewVariant="primary"
                  className={styles.button}
                  text="Вернуться назад"
                  onClick={() => navigate(RouterPathEnum.FirstPage)}
                />
              </div>
            </div>
          </div>
        }
      />
    </div>
  );
};
